


















































































































































































import store from './store'
import {
    //touchScreen,
    update
} from './mixins/mixins'
import {
    isTestMode,
    platform,
    openLinkInBrowser,
    linking
} from './mla-shared/';
const version = require('../package.json').version

export default {
    mixins: [update], // touchScreen
    data(this: any) {
        return {
            drawer: null,
            // isTouchScreen: this.detect(),
            platform: platform(),
            version: version,
            testing: isTestMode(),
            offset: window.pageYOffset,
            disable: false,
            clearLocalStorage: false,
            tabs: [
                { name: 'Home', path: '/home', icon: 'home' },
                { name: 'Instructions', path: '/instructions', icon: 'info' },
                { name: 'Calculator', path: '/calculator', icon: 'mdi-calculator' }
            ],
            breakpoint: this.$vuetify.breakpoint,
            update: 0
        }
    },
    methods: {
        // Reset all data
        resetData: function (this:any) {
            store.dispatch('resetState', this.clearLocalStorage)
            this.clearLocalStorage = false
            this.update += 1
            // this.$router.push({ name: 'Home' })
        },

        // Disable reset warning
        resetDisable: function (this:any) {
            if (this.disable === true) {
                store.dispatch('resetDisable', true)
            }
        },

        // Open etools hub
        etools() {
            openLinkInBrowser('https://etools.mla.com.au/');
        },

        // Open email
        support() {
            linking({
                operation: 'openURL',
                openURL: 'mailto:tools@mla.com.au',
            });
        },

        // Open survey
        survey() {
            openLinkInBrowser('https://forms.office.com/Pages/ResponsePage.aspx?id=HJuCo77s1EmI6U8o95r6EVSRkmKU9bNPpUHjjT0BiexUQTBXNzMzRjg5TjJPR1hNTjBXMDEzS0tXRC4u');
        }
    },
    mounted() {
        window.onscroll = () => {
            (this as any).offset = window.pageYOffset;
        }
        // console.log(this.breakpoint)
    },
    destroyed() {
        window.onscroll = null;
    },
    store
}
